module.exports = __webpack_public_path__ + "static/media/drop-img.7a76ce2f.svg";